export function trimOtp(code, newValue) {
  if (newValue && newValue.length > 6) {
    code.value = newValue.replace(/\s/g, '').slice(0, 6);
  }
}
